<template>
  <div>
    <common-dialog
      ref="dialog"
      width="650px"
      line-form
      unit="存货档案"
      edit-title
      id-key="Id"
      @opened="onOpened"
      :data="data"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :form-rules="rules"
      :save-func="api.save"
      :before-save="onBeforeSave"
      @closed="toClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="存货类型" prop="chlx">
              <el-select v-model="data.chlx">
                <el-option :value="0" label="产品"></el-option>
                <el-option :value="1" label="配件"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="存货编码" prop="chbm">
              <el-input v-model="data.chbm" placeholder="请输入存货编码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="存货名称" prop="chmc">
              <el-input v-model="data.chmc" placeholder="请输入存货名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规格型号" prop="ggxh">
              <el-input v-model="data.ggxh" placeholder="请输入规格型号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="Status">
              <el-select v-model="data.Status">
                <el-option :value="1" label="启用"></el-option>
                <el-option :value="0" label="禁用"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="存货图片" class="notBottom" prop="ImgUrl">
              <el-upload
                class="file-up"
                :action="host + '/api/Common/UploadPicture'"
                list-type="picture-card"
                :show-file-list="true"
                accept=".jpg,.png,.jpeg"
                :on-success="(res, file, fileList) => {onSuccess(res, file, fileList, 'ImgUrl')}"
                :headers="header"
                :file-list="ImgUrl"
                :limit="1"
                :on-exceed="masterFileMax"
                :before-upload="beforePhotoUpload"
              >
                <i class="el-icon-plus"></i>
                <div slot="file" slot-scope="{ file }">
                  <el-image style="width: 148px; height: 148px" :src="file.url" fit="fill"></el-image>
                  <label class="el-upload-list__item-status-label" v-if="file.isDefault">
                    <i :class="{ 'el-icon-upload-success': true, 'el-icon-check': true }"></i>
                  </label>
                  <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file.url)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span class="el-upload-list__item-delete" @click="fileRemove(file)">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="toSave">保存</el-button>
        <el-button @click.stop="close">关 闭</el-button>
      </template>
    </common-dialog>
    <el-dialog :visible.sync="dialogVisible" title="查看图片">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog
  },
  data() {
    return {
      data: {
        Id: 0,
        chlx: null,
        chbm: "",
        chmc: null,
        ggxh: null,
        chfl: null,
        url: "",
        Status: 1
      },
      ImgUrl: [],
      dialogImageUrl: '',
      dialogVisible: false,
      removeImgUrl: [],
      api: require('@/api/ba/mould').default,
      rules: {
        chlx: [{ required: true, message: '存货类型不能为空' }],
        chbm: [{ required: true, message: '存货编码不能为空' }],
        chmc: [{ required: true, message: '存货名称不能为空' }],
        Status: [{ required: true, message: '状态不能为空' }],
        ggxh: [{ required: true, message: '规格型号不能为空' }]
      },
    }
  },
  computed: {
    host() {
      return window.location.origin
    },
    header() {
      let token = localStorage.getItem('token')
      if (token) {
        return { Authorization: 'Bearer ' + token }
      }
      return {}
    },
  },
  methods: {
    onOpened() {
      
    },
    onCreateOpened(data) {
      
    },
    onEditOpened(data) {

    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },
    beforePhotoUpload(file) {
      var limit = 5
      return new Promise((resolve, reject) => {
        let fileTypeLength = file.name.split('.').length
        if (fileTypeLength > 0) {
          let fileType = file.name.split('.')[fileTypeLength - 1].toLowerCase()
          const extension = fileType === 'jpg'
          const extension2 = fileType === 'png'
          const extension4 = fileType === 'jpeg'
          const isSizeBig = file.size / 1024 / 1024 < limit
          if (!extension && !extension2 && !extension4) {
            this.$message.warning(this.salewaynumber == 'en' ? 'Pictures can only be in jpg,jpeg,png format' : '上传图片只能是 JPG、JPEG、PNG 格式!')
            reject(false)
          } else {
            if (isSizeBig) {
              resolve(file)
            } else {
              imageConversion.compressAccurately(file, 1024).then(res => {
                resolve(res)
              })
            }
          }
        }
      })
    },
    onSuccess(res, file, fileList, name) {
      if (res.Code == 0) {
        this[name].push({ url: '/api' + res.Data, url2: res.Data, T: 0 })
      } else {
        fileList.splice(fileList.length - 1, 1)
        this.$message.error(res.Msg)
      }
    },
    fileRemove(file, fileList, name) {
      var index = this.ImgUrl.findIndex(x => x.url == file.url)
      if (index > -1) {
        if (file.T == 0) {
          this.ImgUrl.splice(index, 1)
        } else {
          this.removeImgUrl.push(this.ImgUrl.splice(index, 1)[0])
        }
      }
    },
    masterFileMax(files, fileList) {
      this.$message.warning(`请最多上传 1 张图片。`)
    },
    onBeforeSave() {
      
    },
    toSave() {

    },
    toClosed() {
      this.ImgUrl = [];
      this.removeImgUrl = [];
    },
  }
}
</script>
<style lang="scss" scoped>
/deep/ .notBottom .el-form-item__content {
  border-bottom: none;
}
</style>
